export default "__VITE_ASSET__DAP$GYt4__"